import React, { useState } from 'react';
import { useClickOutside } from '../utils';
import { default as Styles, colors } from '../styles';

const Legend = ({
  active = [],
  average,
  min,
  max,
  source = false,
  title = false,
}) => {
  const [expanded, set_expanded] = useState(false);
  const ref = useClickOutside(() => (expanded ? set_expanded(!expanded) : {}));

  const filtered = active.filter(v => v.label !== 'placeholder');

  return !expanded ? (
    <div
      style={{
        cursor: 'pointer',
        position: 'absolute',
        top: '10px',
        right: '10px',
        backgroundColor: colors.chart_bg,
        borderRadius: '6px',
        ...Styles.padded('r'),
        ...Styles.col_center('center'),
      }}
      onClick={() => set_expanded(!expanded)}
    >
      <svg viewBox="0 0 18 20" width="18" height="20">
        <rect fill={colors.chart_bg} width="18" height="20" rx="4" />
      </svg>
    </div>
  ) : (
    <div
      ref={ref}
      aria-hidden="true"
      style={{
        backgroundColor: colors.chart_tips,
        cursor: 'pointer',
        opacity: expanded ? 0.8 : 0,
        pointerEvents: expanded ? 'auto' : 'none',
        width: '80%',
        ...Styles.pinned,
        ...Styles.elevation('max'),
      }}
      onClick={() => set_expanded(!expanded)}
    >
      <div style={{ ...Styles.row_start('align-start') }}>
        <div
          style={{
            color: colors.pristine,
            textTransform: 'uppercase',
            ...Styles.padded('l'),
            ...Styles.col_between('start'),
            ...Styles.stretch,
          }}
        >
          <div>
            {title && <p style={{ ...Styles.bold }}>{title}</p>}
            <br aria-hidden="true"/>

            <p
              style={{
                ...Styles.row_between('center'),
                ...Styles.paddedY('r'),
              }}
            >
              <span style={{ ...Styles.font('s') }}>min </span>
              <span style={{ ...Styles.numbers }}>{min}</span>
            </p>
            <p
              style={{
                ...Styles.row_between('center'),
                ...Styles.paddedY('r'),
              }}
            >
              <span style={{ ...Styles.font('s') }}>max </span>
              <span style={{ ...Styles.bold, ...Styles.numbers }}>{max}</span>
            </p>
            {average && (
              <p
                style={{
                  ...Styles.row_between('center'),
                  ...Styles.paddedY('r'),
                }}
              >
                <span style={{ ...Styles.font('s') }}>average</span>
                <span style={{ ...Styles.numbers }}>{average}</span>
              </p>
            )}
          </div>

          {source && (
            <div style={{ ...Styles.stretch }}>
              <p style={{ ...Styles.bold, ...Styles.font('xs'), flexGrow: 1 }}>
                Source:
                <span style={{ ...Styles.bold }}> {source}</span>
              </p>
            </div>
          )}
        </div>

        <div aria-label="hidden" style={{ ...Styles.padded('l') }}>
          {filtered.map((v, index) => {
            return (
              <div
                key={v.id}
                style={{
                  ...Styles.uppercase,
                  color: v.color,
                  ...Styles.paddedY('r'),
                  ...Styles.row_start('center'),
                }}
              >
                <p
                  style={{
                    ...(index !== filtered.length && Styles.marginRight('r')),
                  }}
                >
                  <svg viewBox="0 0 10 10" width="10" height="10">
                    <circle
                      strokeWidth="0"
                      fill={'currentColor'}
                      cx={5}
                      cy={5}
                      r="4"
                    />
                  </svg>
                </p>

                <p
                  style={{
                    ...Styles.truncate_sx(100),
                    ...(index !== filtered.length && Styles.marginRight('r')),
                  }}
                >
                  {v.label}
                </p>
                <p
                  style={{
                    ...Styles.bold,
                    ...Styles.numbers,
                    textAlign: 'right',
                    flexGrow: 1,
                  }}
                >
                  {v.raw}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default Legend;
